// 12-hour time formatting for schedule/class displays.
// DB time values are 'HH:MM' or 'HH:MM:SS' (24-hour). We never show military
// time in the UI.

/** 'HH:MM[:SS]' → 'h:mm AM/PM' (e.g. '16:00:00' → '4:00 PM'). */
export function formatTime12(time: string): string {
  const parts = time.split(':');
  const h = Number(parts[0]);
  const m = Number(parts[1] ?? '0');
  if (Number.isNaN(h)) return time;
  const period = h < 12 ? 'AM' : 'PM';
  const h12 = h % 12 === 0 ? 12 : h % 12;
  const mm = String(Number.isNaN(m) ? 0 : m).padStart(2, '0');
  return `${h12}:${mm} ${period}`;
}

/** Whole-hour label (e.g. 14 → '2 PM', 0 → '12 AM'). */
export function formatHour12(hour: number): string {
  const period = hour < 12 ? 'AM' : 'PM';
  const h12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${h12} ${period}`;
}
